// extracted by mini-css-extract-plugin
export default {"base":"SearchPopover_base__Mcm2h","open":"SearchPopover_open__STl2f","title":"SearchPopover_title__JJpjJ","showing":"SearchPopover_showing__fKSS-"};